export type CalculatorSummary = {
  calculatorId: string;
  classification: string;
  ichdUrl: string;
  questionCount: number;
  display: boolean;
};

export type Calculator = {
  calculatorId: string;
  classification: string;
  ichdUrl: string;
  questions: Question[];
};

export type CalculatorCriteria = {
  calculatorId: string;
  display: boolean;
  classification: string;
  ichdUrl: string;
  parentCalculatorId: string;
  criteria: Criteria[];
}

export type Criteria = {
  criteriaType: CriteriaType;
  criteriaValue: string;
  criteriaQuestions: [
    {
      questionId: string;
      validValue: string;
      criteriaType: CriteriaType;
    }
  ];
  childCriteria: Criteria[];
}

export const ALL_CRITERIA_TYPES = ["lower", "higher", "range", "equal"];

export type CriteriaType = typeof ALL_CRITERIA_TYPES[number];

export type Question = {
  questionId: string;
  question: string;
  additionalInfo: string;
  answerType: string;
  answers: QuestionAnswer[];
};

export type QuestionAnswer = {
  value: number;
  patientDisplay: string;
  clinicianDisplay: string;
};

export type Responses = { [key: string]: boolean | string | number };
